var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDashArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35413 3.95705C8.30768 3.91048 8.25251 3.87354 8.19176 3.84834C8.13102 3.82313 8.06589 3.81015 8.00013 3.81015C7.93436 3.81015 7.86924 3.82313 7.80849 3.84834C7.74775 3.87354 7.69257 3.91048 7.64613 3.95705L3.06113 8.54304C2.77986 8.82443 2.39834 8.98257 2.00048 8.98267C1.60262 8.98276 1.22102 8.8248 0.939626 8.54354C0.658232 8.26228 0.500094 7.88075 0.5 7.48289C0.499906 7.08504 0.657865 6.70344 0.939127 6.42204L5.52513 1.83605C6.18216 1.18082 7.07221 0.812866 8.00013 0.812867C8.92804 0.812867 9.81809 1.18082 10.4751 1.83605L15.0611 6.42204C15.3424 6.70344 15.5003 7.08504 15.5003 7.4829C15.5002 7.88075 15.342 8.26228 15.0606 8.54354C14.7792 8.8248 14.3976 8.98276 13.9998 8.98267C13.6019 8.98257 13.2204 8.82443 12.9391 8.54304L8.35413 3.95705Z",
    fill: "#9D9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashArrow);
export default __webpack_public_path__ + "static/media/icon-dash-arrow.db41b6856d7e53dd19ffea9017c125fa.svg";
export { ForwardRef as ReactComponent };